module.exports = __webpack_public_path__ + "assets/img/ab3.39cba569.png";